import { userInit } from 'redux/reducers/init';
import {
  requestAuthentication,
  requestLogin,
  requestLoginFailure,
  requestLoginSuccess,
  requestLogout,
  requestAuthenticationSuccess,
  requestAuthenticationFailure,
} from 'redux/actions/actions';

import { createReducer } from '@reduxjs/toolkit';

const user = createReducer(userInit, {
  [requestLogin.type]: (state, action) => {
    state.isLoading = true;
  },
  [requestLoginSuccess.type]: (state, action) => {
    const { user } = action.payload;

    state.isLoading = false;
    state.isLoggedIn = true;
    state.userId = user.userId;
    state.userName = user.name;
  },
  [requestLoginFailure.type]: (state, action) => {
    const { errorMessage } = action.payload;

    state.isLoading = false;
    state.isLoggedIn = false;
    state.unValidated = true;
    state.errorMessage = errorMessage;
  },
  [requestLogout.type]: (state, action) => {
    state.isLoggedIn = false;
  },
  [requestAuthentication.type]: (state, action) => {
    state.isLoading = true;
  },
  [requestAuthenticationSuccess.type]: (state, action) => {
    state.isLoading = false;
    state.isLoggedIn = true;
  },
  [requestAuthenticationFailure.type]: (state, action) => {
    state.isLoading = false;
    state.isLoggedIn = false;
  },
});

export default user;
